/* eslint-disable jsx-a11y/anchor-is-valid */
import { ArrowDown16, ArrowUp16, Delete16 } from "@carbon/icons-react"
import { SelectableTile, Tile } from "carbon-components-react"
import classNames from "classnames"
import Button from "ui/Button"
import TileFooter from "ui/TileFooter/TileFooter"
import TileTitle from "ui/TileTitle/TileTitle"

import "./TileWrapper.scss"
import TileContent from "ui/TileContent/TileContent"

export const TileButton = (props) => {
    return (
        <Button
            size="small"
            kind="ghost"
            hasIconOnly
            {...props}
        />
    )
}

export const TileDeleteButton = (props) => {
    return (
        <TileButton
            renderIcon={Delete16}
            iconDescription="Delete"
            {...props}
        />
    )
}

const TileWrapper = (props) => {

    const { style, title, footer, classes, goUp, goDown, enableGoUp, enableGoDown, onClick, onChange, onTitleClicked, selected, avatar, selectable } = props
    const className = classNames(classes, "tile-wrapper", {
        "selected": selected
    })
    const TileEleemnt = selectable ? SelectableTile : Tile
    return (
        <TileEleemnt style={style} className={className} onClick={onClick} onChange={onChange} selected={selected}>
            {
                avatar && (
                    <div className="tile-avatar">
                        {avatar}
                    </div>
                )
            }
            {
                title && (
                    <TileTitle
                        titleComponent={props.titleComponent}
                        onClick={onTitleClicked}
                        disableTitlePadding={props.disableTitlePadding}
                    >
                        {title}
                    </TileTitle>
                )
            }
            {
                props.children && (
                    <TileContent>
                        {props.children}
                    </TileContent>
                )
            }
            {
                enableGoUp && (
                    <a className="tile-sort__goup" onClick={goUp}>
                        <ArrowUp16 />
                    </a>
                )
            }
            {
                enableGoDown && (
                    <a className="tile-sort__godown" onClick={goDown}>
                        <ArrowDown16 />
                    </a>
                )
            }
            {
                footer && (
                    <TileFooter>
                        {footer}
                    </TileFooter>
                )
            }
        </TileEleemnt>
    )
}

export default TileWrapper